import { lazy } from 'react';
import { widgetRegistry } from '../../../core/widgets/WidgetRegistry';
import { RetreatStatsWidget } from './RetreatStatsWidget';
import { RetreatUpcomingWidget } from './RetreatUpcomingWidget';
import { CheckInWidget } from './CheckInWidget';
import { DefectWidget } from './DefectWidget';

// Chart widget: recharts loads only when the widget is shown.
const ProgramStatsWidget = lazy(() => import('./ProgramStatsWidget').then(m => ({ default: m.ProgramStatsWidget })));

/**
 * Register all Retreat widgets
 */
export function registerRetreatWidgets() {
    widgetRegistry.register({
        id: 'retreat-stats',
        title: 'Freizeit-Statistiken',
        description: 'Übersicht über Anmeldungen und Finanzen',
        component: RetreatStatsWidget,
        category: 'retreat',
        requiredPermission: 'retreat', // Adjust if permission name is different (e.g. 'retreat_manager')
        defaultSize: 'half' as any,
        defaultEnabled: true,
        order: 50,
    });

    widgetRegistry.register({
        id: 'retreat-upcoming',
        title: 'Nächste Freizeit',
        description: 'Countdown und Termine',
        component: RetreatUpcomingWidget,
        category: 'retreat',
        requiredPermission: 'retreat',
        defaultSize: 'half' as any,
        defaultEnabled: true,
        order: 51,
    });

    widgetRegistry.register({
        id: 'retreat-checkin',
        title: 'Anreise-Status',
        description: 'Echtzeit-Übersicht der Ankunft',
        component: CheckInWidget,
        category: 'retreat',
        requiredPermission: 'retreat',
        defaultSize: 'half' as any,
        defaultEnabled: true,
        order: 52,
    });

    widgetRegistry.register({
        id: 'retreat-program-stats',
        title: 'Programm-Aufrufe',
        description: 'Live-Statistik der öffentlichen Programmseite',
        component: ProgramStatsWidget,
        category: 'retreat',
        requiredPermission: 'retreat.program-stats',
        defaultSize: 'small' as any,
        defaultEnabled: true,
        order: 54,
    });

    widgetRegistry.register({
        id: 'retreat-defects',
        title: 'Mängel & Defekte',
        description: 'Offene Mängel in Gebäuden',
        component: DefectWidget,
        category: 'retreat',
        requiredPermission: 'retreat',
        defaultSize: 'half' as any,
        defaultEnabled: true,
        order: 53,
    });
}
